module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0002.jpg?v=d3d6a160";